import { flow, get, forEach, castArray } from 'lodash/fp';

export const initModule = ({ match, module, withFetchAction = true }) =>
  function* ({ injectReducer }) {
    if (module.load) {
      module = yield module.load();
    }

    const reducer = get(['reducer'], module);

    if (reducer) {
      flow(castArray, forEach(injectReducer))(reducer);
    }

    const initAction = get(['actions', 'init'], module);
    const fetchAction = get(['actions', 'fetch'], module);

    if (initAction) {
      yield initAction(match);
    }

    if (withFetchAction && fetchAction) {
      yield fetchAction(match);
    }
  };

export default ({ getMatched, App, withFetchAction }) =>
  function* ({ getCurrentLocation }) {
    const { pathname } = getCurrentLocation();
    const matched = getMatched(pathname);

    if (!matched) {
      throw new Error('Pathname is not matched!', pathname);
    }

    const {
      route: { component: universalComponent },
      match,
    } = matched;

    if (App) {
      yield initModule({
        match,
        module: App,
        withFetchAction,
      });
    }

    yield initModule({
      match,
      module: universalComponent,
      withFetchAction,
    });
  };
